import type { SourceChannel } from '@/types/sale';

/**
 * The source channel the ticketbox tags every sale, quote and promo preview
 * with, unless the cashier picked another one for a promo (e.g. a TikTok
 * campaign customer).
 *
 * The backend gates a discount's `conditions.sourceChannels[]` on this tag and
 * refuses a missing one rather than guessing, so an untagged sale failed every
 * channel-locked promo — including a "ticketbox only" one.
 */
export const SOURCE_CHANNEL: SourceChannel = 'ticketbox';

/** The channel actually sent: the cashier's pick, else the ticketbox's own. */
export function effectiveSourceChannel(picked?: SourceChannel | string | null): SourceChannel {
  return (picked || SOURCE_CHANNEL) as SourceChannel;
}
